import { PreguntaExportador } from "../PreguntaExportador";
import { PreguntasTipoEnum } from "@shared/enums";

export class PreguntaFlowRandomExportador extends PreguntaExportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.FLOW_RANDOM;
    }
}
